import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import TeamEdit from './TeamEdit';
import { growlErrors } from '../../../../../utils/NotificationUtil';
import { Loading } from '../../../../../components/Loading';
import { AccountContext } from '../../../../../components/AccountContext';
import { NotificationContext } from '../../../../../components/GrowlNotifications';

export const EXEC_SURVEY = gql`
  query($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      id
      executiveReport(id: $id) {
        id
        executiveReportSurveys {
          id
        }
      }
    }
  }
`;

const TeamEditContainer = ({ ...rest }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { reportId } = useParams();
  const variables = {
    id: reportId,
    accountId: currentAccount,
  };
  return (
    <Query query={EXEC_SURVEY} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
          return `Error ${error.message}`;
        }
        const { executiveReport: reportSurveyList } = data.account;
        return <TeamEdit {...rest} reportSurveyList={reportSurveyList} />;
      }}
    </Query>
  );
};

export default TeamEditContainer;
